import styled from "styled-components";
import { headerCommonStyle } from "./common";

export const H1 = styled.h1`
  ${headerCommonStyle}
  font-size: ${({ theme }) => theme.fontSize.xl3};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
`;
